import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Table } from "@/features/Table";
import { getDownloadCenterColumns, TDownloadCenter } from "./columns";
import { FilterDownloadCenterOPCVM } from "./filter";

export default function DowloadCenterTable({
  client,
  table_name,
}: {
  client: string;
  table_name: string;
}) {
  const { t, i18n } = useTranslation(["common"]);
  const columns = useMemo(
    () => getDownloadCenterColumns(t),
    [t, i18n.language],
  );

  return (
    <Table<TDownloadCenter, any>
      label={t("download_center.title", { defaultValue: "Download Center" })}
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<FilterDownloadCenterOPCVM />}
      download_button={false}
      actions={[]}
      disable_translations_request={true}
      columnVisibilityInit={{
        id: false,
      }}
    />
  );
}
